import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';

import { recordTellentAssistantEngagement } from './engagements.effects';

const effects = { recordTellentAssistantEngagement };

export const provideTellentAssistantEngagementsEffects = provideEffects(effects);

export const provideTellentAssistantEngagementsNgrx = [provideTellentAssistantEngagementsEffects];

@NgModule({
  imports: [EffectsModule.forFeature(effects)],
})
export class TellentAssistantEngagementsStoreModule {}
